/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import RedactorEditor from '../RedactorEditor';
import UIImage from './ui/UIImage';
import UIButton from './ui/UIButton';
import UISelectValue from './ui/UISelectValue';
import uuid from 'uuid/v4';

const BannersRow = ({
  activeLanguage, handlerSetComponents, components, languages, id, reusableComponent, reusableComponentSlugname, slider,
}) => {

  const initialState = {
    type: 'BannersRow',
    rows: 1,
    items: [],
  };

  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);
  const [showOptions, setShowOptions] = useState(false);
  const [updatedData, setUpdatedData] = useState(false);
  const [items, setItems] = useState([]);

   const [rows, setRows] = useState(1);

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);
      if (component) {

        const {
          rows: currentRows,
          items: currentItems,
        } = component;

        setState(component);
        setRows(currentRows);
        setItems(currentItems);

      } else {
        const componentObj = {
          id,
          component: state,
        };

        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const construction = {
      type: state.type,
      compId: state.compId || '',
      rows,
      items,
    }

    handlerSetComponents({ component: construction }, componentIndex);
  }, [
    rows,
    updatedData,
  ]);

  const titleChange = (e) => {
    const itemIndex = e.target.getAttribute('itemindex');
    const { name, value } = e.target;
    if (name === "bannerClick" || name === "link.url"){ items[itemIndex][name] = value }
    else { items[itemIndex][name][activeLanguage] = value }
    setItems(items);
    setUpdatedData(uuid());
  }

  const updatedBgImage = (value, index) => {
    items[index]['bgImage'][activeLanguage] = value;
    setItems(items);
    setUpdatedData(uuid());
  }

  const colorChange = (color, index) => {
    items[index]['color'] = color;
    setItems(items);
    setUpdatedData(uuid());
  }

  const titleChangeFromRedactor = (value, itemIndex) => {
    //const itemIndex = e.target.getAttribute('itemindex');
    items[itemIndex]['text'][activeLanguage] = value
    setItems(items);
    setUpdatedData(uuid());
  }

  const titleChangeFromButton = (value, itemIndex) => {
    items[itemIndex]['link'] = {...value};
    setItems(items);
    setUpdatedData(uuid());
  }

  const pushAnItemToItems = () => {
    items.push({
      color: 'white', // or Red
      preTitle: { en: '' },
      title: { en: '' },
      text: { en: '' },
      bgImage: { en: '' },
      link: {
        text: {
          en: '',
        },
        url: '',
      },
      bannerClick: '',
      desktopVideoUrl: {
        en: '',
        es: '',
      },
    });
    setItems(items);
    setUpdatedData(uuid());
  };

  const onDragEnd = (result) => {
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) {
      return;
    }
    if (destination.droppableId === source.droppableId && destination.index === source.index) return

    switch (source.droppableId) {
      // origin same as destination, order items
      case destination.droppableId: {
        //const newOrder = reorder(items, source.index, destination.index);
        [items[source.index], items[destination.index]] = [items[destination.index], items[source.index]];


        setItems(items);
        setUpdatedData(uuid());
        break;
      }

      default: {
        break;
      }
    }
  };

  const removeFromItems = index => {
    items.splice(index, 1)
    setItems(items);
    setUpdatedData(uuid());
  }

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div className="flex flex-wrap my-4 text-black">
        <div className="">
          <label
            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          >
            Rows
          </label>
          <div className="relative">
            <input
              className="appearance-none uppercase block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
              type="text"
              onChange={e => setRows(e.target.value)}
              value={rows}
            />
          </div>
        </div>
      </div>
      <div className="flex justify-start flex-col text-black">
        <Droppable droppableId="selected">
          {(provided, snapshot) => (
            <div ref={provided.innerRef}
              className={`${snapshot.isDraggingOver ? 'bg-grey' : 'bg-grey-lighter'} min-h-30 mb-4 rounded w-full p-2 relative`}>
              {items.map((element, index) => {
                const {
                  color = "white", // or Red
                  preTitle = { en: '' },
                  title = { en: '' },
                  text = { en: '' },
                  bgImage = { en: '' },
                  link = { text: { en: '' }, url: '' },
                  bannerClick = "",
                  desktopVideoUrl = { en: '' },
                } = element;
                return (
                  <Draggable
                    key={`${id}_${index}`}
                    draggableId={`${id}_${index}`}
                    index={index}
                    activeLanguage={activeLanguage}>
                    {(provided, snapshot, component) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        className={`relative bg-gray-200 bg-white min-h-30 mb-2 rounded w-full p-2`}
                        style={provided.draggableProps.style}
                      >
                        <div className="flex flex-wrap mb-2">
                          <div className="bg-grey-light cursor-pointer font-bold mr-1 p-2 px-4 rounded text-center">{index + 1}</div>
                          <div className="bg-grey-light cursor-pointer text-center flex-2 p-2 rounded" {...provided.dragHandleProps}> =</div>
                          <div className="cursor-pointer p-2 rounded" onClick={() => removeFromItems(index)}><span className="font-icon icon-close-btn1" /></div>
                        </div>
                        <div className="w-full mt-2">
                          <UIImage
                            activeLanguage={activeLanguage}
                            imageUrl={bgImage}
                            setImageUrl={updatedBgImage}
                          />
                        </div>
                        <div className="flex flex-wrap w-full mt-2">
                          <div className="flex-1">
                            <label
                              className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                            >
                              Video Url
                            </label>
                            <input
                              className="appearance-none block
                        bg-gray-200 text-gray-700 border border-red-500
                        rounded py-3 px-4 w-full leading-tight focus:outline-none
                        focus:bg-white"
                              itemindex={index}
                              name="desktopVideoUrl"
                              type="text"
                              onChange={titleChange}
                              value={desktopVideoUrl?.[activeLanguage]}
                            />
                          </div>
                        </div>
                        <div className="flex flex-wrap w-full mt-2">
                          <div className="flex-1 mr-2">
                            <label
                              className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                            >
                              Pre Title
                          </label>
                            <input
                              className="appearance-none block
                        bg-gray-200 text-gray-700 border border-red-500
                        rounded py-3 px-4 w-full leading-tight focus:outline-none
                        focus:bg-white"
                              itemindex={index}
                              name="preTitle"
                              type="text"
                              onChange={titleChange}
                              value={preTitle[activeLanguage]}
                            />
                          </div>
                          <div className="">
                            <UISelectValue
                              label={'Layout Color'}
                              setValue={color => colorChange(color, index)}
                              value={color}
                              options={[
                                { value: "white", label: "White" },
                                { value: "red", label: "Red" },
                              ]}
                            />
                          </div>
                        </div>
                        <div className="w-full md:w-full md:mb-0 mt-2">
                          <label
                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                          >
                            Title
                        </label>
                          <input
                            className="appearance-none block
                      bg-gray-200 text-gray-700 border border-red-500
                      rounded py-3 px-4 w-full leading-tight focus:outline-none
                      focus:bg-white"
                            type="text"
                            itemindex={index}
                            name="title"
                            onChange={titleChange}
                            value={title[activeLanguage]}
                          />
                        </div>
                        <div className="w-full md:w-full md:mb-0 mt-2">
                          <label
                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                          >
                            Text
                        </label>
                          <RedactorEditor
                            text={text[activeLanguage]}
                            setText={text => titleChangeFromRedactor(text, index)}
                            id={`${id}_${index}`}
                          />
                        </div>
                        <UIButton
                          buttonData={link}
                          setButtonData={link => titleChangeFromButton(link, index)}
                        />
                        <div className="w-full md:w-full md:mb-0 mt-2">
                          <label
                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                          >
                            Banner Click
                        </label>
                          <input
                            className="appearance-none block
                      bg-gray-200 text-gray-700 border border-red-500
                      rounded py-3 px-4 w-full leading-tight focus:outline-none
                      focus:bg-white"
                            type="text"
                            itemindex={index}
                            name="bannerClick"
                            onChange={titleChange}
                            value={bannerClick}
                          />
                        </div>
                      </div>
                    )}
                  </Draggable>
                )
              })}
              {provided.placeholder}
            </div>

          )}

        </Droppable>


        <div className="hover:bg-blue-light hover:text-white rounded w-full">
          <div
            className={`block appearance-none w-full
                bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8
                rounded leading-tight focus:outline-none focus:bg-white
                focus:border-gray-500 text-center`}
            onClick={pushAnItemToItems}
          >+</div>
        </div>
      </div>
    </DragDropContext>
  );
};

BannersRow.propTypes = {
  activeLanguage: PropTypes.string.isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  reusableComponent: PropTypes.shape(),
  slider: PropTypes.bool,
};
BannersRow.defaultProps = {
  reusableComponent: null,
  slider: false,
};

export default BannersRow;
